<template>
  <div>
    <p>有鱼记账APP（由上海及未科技有限公司开发运营，下称“有鱼”）</p>
    <p>为更好地享受信用卡相关权益和服务，本人知晓并同意上海浦东发展银行出于活动权益服务，提供本人申卡情况类信息（申请状态，审批状态，首刷状态，状态变更时间等）和手机号，至“有鱼”。</p>
    <p>上述所列信息授权期限为本人点击“立即提交”之日起至上海浦东发展银行股份有限公司与“有鱼”合作终止之日止。</p>
    <p>“有鱼”对上述信息具有保密责任，并将在上述处理目的、处理方式和个人信息种类范围内处理信息。</p>
    <p>如有任何问题请联系官方邮箱：jwxxl@yofish.com</p>
  </div>
</template>
<script>
export default {
  name: 'Agreement',
};
</script>
<style lang="scss" scoped>
p {
  font-size: 22px;
  font-weight: 400;
  color: #666666;
  line-height: 30px;
}
</style>
